import React, { useState, useRef } from "react";
import { useDispatch, useSelector, connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";

import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import { login } from "../actions/auth";
import { baseurl } from "../utils/const";
import { getUser } from "../helpers/utils";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const Welcome = ({ history, ...props }) => {
  const form = useRef();
  const checkBtn = useRef();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  const dispatch = useDispatch();

  React.useEffect(() => {
    let search = props.location.search;
    const params = new URLSearchParams(search);
    const auth = params.get("token");

    if (auth && auth.split(".") && auth.split(".")[1]) {
      const auth_data = JSON.parse(atob(auth.split(".")[1]));
      const auth_email = auth_data["email"];
      const auth_password = atob(auth_data["password"]);
      if (auth_email && auth_password) {
        loginEvent(auth_email, auth_password);
      }
    } else {
      const iam = getUser()?.user?.iam;
      if (isLoggedIn) {
        if (iam === "buyer") {
          return <Redirect to={baseurl + "/profile/update"} />;
        } else {
          return <Redirect to={baseurl + "/profile"} />;
        }
      }
    }
  }, [history, isLoggedIn, props.location.search]);

  const onChangeEmail = (e) => setEmail(e.target.value);
  const onChangePassword = (e) => setPassword(e.target.value);

  const togglePasswordVisibility = () => setShowPass((prev) => !prev);

  function redirectToService() {
    const currentUser = localStorage.getItem("user");
    if (currentUser) {
      const user = JSON.parse(currentUser);
      if (user?.access) {
        if (user?.user?.iam === "buyer") {
          history.push(baseurl + "/profile/update");
        } else {
          history.push(baseurl + "/profile");
        }
      }
    }
  }

  const loginEvent = (email, password) => {
    dispatch(login(email, password))
      .then(() => {
        redirectToService();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      loginEvent(email, password);
    } else {
      setLoading(false);
    }
  };

  const handleOkClick = () => {
    window.parent.postMessage(
      { type: "CLOSE_MODAL" },
      "https://www.merchantbay.com/"
    );
  };

  return (
    <div className="signInPage d-flex align-items-center justify-content-center h-100">
      <div className="signInForm">
        <div className="succMessageBox">
          <h3>Thank you for signing up!</h3>
          <div className="succMessage">
            <p>
              We will contact you within 24 Hours If you don't receive an email
              from us please contact
              <span className="email"> success@merchantbay.com </span>
            </p>
          </div>
          <div className="okWrap">
            <button
              className="btn btn-primary btn-okay"
              onClick={handleOkClick}
            >
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect()(Welcome);
